module.exports = __webpack_public_path__ + "static/models/stadium_building.7af3035.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/stadium_building.json
// module id = 539
// module chunks = 1